// Select elements
const dropdown_select_btn = document.querySelector('#dropdown_select');
const dropdown_select_btn_txt = document.querySelector('#dropdown_select .dropdown__text');
const dropdown_select_btn_img = document.querySelector('#dropdown_select .dropdown__img');
const dropdown_season_menu = document.querySelector('#dropdown_list');
const dropdown_options = document.querySelectorAll('#dropdown_list li');
const modal = document.getElementById('product-gallery-modal');

var qtyMinus = document.getElementsByClassName('qty__adjust--minus'),
    qtyPlus = document.getElementsByClassName('qty__adjust--plus'),
    qtyValueInput = document.getElementsByClassName('qty__num'),
    currentVal = 1;

let test_src = "";

// Track state for menu and focus
let isMenuOpen = false;
let currentIndex = (dropdown_options.length - 1); // To track the currently focused option

// Set ARIA roles
dropdown_select_btn.setAttribute('aria-haspopup', 'listbox');
dropdown_select_btn.setAttribute('aria-controls', 'dropdown_list');
dropdown_season_menu.setAttribute('role', 'listbox');
dropdown_season_menu.setAttribute('tabindex', '-1');

dropdown_options.forEach(option => {
  option.setAttribute('role', 'option');
  option.setAttribute('tabindex', '-1');
});

// Toggle the menu visibility
function toggleMenu() {
  const isOpen = dropdown_season_menu.classList.contains('active');
  if (!isOpen) {
    dropdown_season_menu.classList.add('active');
    dropdown_select_btn.setAttribute('aria-expanded', 'true');
    isMenuOpen = true;
    focusOption();
  } else {
    dropdown_season_menu.classList.remove('active');
    dropdown_select_btn.setAttribute('aria-expanded', 'false');
    isMenuOpen = false;
  }
}

// Handle clicking outside the menu to close it
function closeMenuOnClickOutside(event) {
  const isClickInside = dropdown_select_btn.contains(event.target) || dropdown_season_menu.contains(event.target);
  if (!isClickInside) {
    dropdown_season_menu.classList.remove('active');
    dropdown_select_btn.setAttribute('aria-expanded', 'false');
    isMenuOpen = false;
  }
}

// Find selected row and fetch its class (to grab it's img);
function fetchRowClass(ele){
  if(ele) {
    let test_classes = ele.target.classList.value.split(" "),
      curr_var_row = "";
      test_classes.forEach(function(cls){
        if(cls.includes('variant-row')){
            curr_var_row = cls;
        }
      })
    return curr_var_row;
  } 
}

// Close the menu and select the value when an option is clicked
function onOptionClick() {
  dropdown_options.forEach(option => {
    option.addEventListener('click', function(event) {
      const selectedValue = event.target.innerText;
      dropdown_select_btn_img.src = document.querySelector(`.${fetchRowClass(event)} .variant-featured_image`).src;
      dropdown_select_btn_txt.innerText = selectedValue;
      dropdown_season_menu.classList.remove('active');
      dropdown_select_btn.setAttribute('aria-expanded', 'false');
      isMenuOpen = false;
      focusOption();
    });
  });
}

// Handle keyboard events for accessibility
function handleKeyPress(event) {
  const { key } = event;
  if (!isMenuOpen && (key === 'Enter' || key === 'ArrowDown')) {
    toggleMenu();
    return;
  }

  if (isMenuOpen) {
    switch (key) {
      case 'ArrowDown':
        moveFocusDown();
        break;
      case 'ArrowUp':
        moveFocusUp();
        break;
      case 'Enter':
        selectOption(event.target);
        event.preventDefault();
        event.target.click(); // Triggers the exact same behavior as a mouse click
        break;
      case 'Escape':
        closeMenu();
        removeFocusTrap(); // Clean up the listener
        break;
      case 'Tab':
        return;
      default:
        break;
    }
  }
}

// Move the focus down through the options
function moveFocusDown() {
  if (currentIndex < dropdown_options.length - 1) {
    currentIndex++;
  } else {
    currentIndex = 0;
  }
  focusOptionKeyPress();
}

// Move the focus up through the options
function moveFocusUp() {
  if (currentIndex > 0) {
    currentIndex--;
  } else {
    currentIndex = dropdown_options.length - 1;
  }
  focusOptionKeyPress();
}

// Focus the currently selected option
function focusOption() {
  dropdown_options.forEach((option, index) => {
    option.classList.remove('current');
    option.setAttribute('aria-selected', 'false');
    if ((option.innerText === dropdown_select_btn_txt.innerText)) {
      currentIndex = index;
      option.classList.add('current');
      option.setAttribute('aria-selected', 'true');
      option.focus();
    }
  });
}

function focusOptionKeyPress() {
  if (currentIndex >= 0 && currentIndex < dropdown_options.length) {
    dropdown_options.forEach((option, index) => {
      option.classList.remove('current');
      option.setAttribute('aria-selected', 'false');
      if (index === currentIndex) {
        option.classList.add('current');
        option.setAttribute('aria-selected', 'true');
        option.focus();
      }
    });
  }
}

// Select the currently focused option
function selectOption(option) {
  const selectedValue = option.innerText;
  dropdown_select_btn_txt.innerText = selectedValue;

  // Update image — find row class from option
  const rowClass = Array.from(option.classList).find(cls => cls.includes('variant-row'));
  const image = document.querySelector(`.${rowClass} .variant-featured_image`);
  if (image) {
    dropdown_select_btn_img.src = image.src;
  }

  // Update currentIndex
  dropdown_options.forEach((opt, index) => {
    if (opt.innerText === selectedValue) {
      currentIndex = index;
    }
  });

  closeMenu();
}


// Close the menu
function closeMenu() {
  dropdown_season_menu.classList.remove('active');
  dropdown_select_btn.setAttribute('aria-expanded', 'false');
  isMenuOpen = false;
  currentIndex = -1;
}

/*** QTY Code ***/
function valUpdateWrapper() {
  $(".quantity_selector .qty__adjust--minus").addClass("js-qty__disable");  

  for (var i = 0; i < qtyMinus.length; i++) {
    qtyMinus[i].addEventListener('click', updateSiblingValueMinus);
  }
  for (var i = 0; i < qtyPlus.length; i++) {
    qtyPlus[i].addEventListener('click', updateSiblingValuePlus);
  }
  for (var i = 0; i < qtyValueInput.length; i++) {
    qtyValueInput[i].addEventListener('input', updateValue);
    qtyValueInput[i].setAttribute('aria-label', 'Product quantity');
  }

  function updateValue(e) {
    currentVal = e.target.value;
    if(currentVal > 1) {
      $(this).siblings('.qty__adjust--minus').removeClass("js-qty__disable");
    } else {
      $(this).siblings('.qty__adjust--minus').addClass("js-qty__disable");
    }
  }

  function updateSiblingValueMinus(e) {
    currentVal = parseInt($(this).siblings('input').val());
    if(currentVal == 2) {
      $(this).addClass("js-qty__disable");
    }
    currentVal -= 1;
    $(this).siblings('input').val(currentVal);
  }

  function updateSiblingValuePlus(e) {
    currentVal = parseInt($(this).siblings('input').val());
    if(currentVal >= 1) {
      $(this).siblings('.qty__adjust--minus').removeClass("js-qty__disable");
    }
    currentVal += 1;
    $(this).siblings('input').val(currentVal);
  }
};

// Initialize event listeners
function init() {
  dropdown_select_btn.addEventListener('click', toggleMenu);
  onOptionClick();
  document.addEventListener('click', closeMenuOnClickOutside);
  dropdown_select_btn.addEventListener('keydown', handleKeyPress);
  dropdown_season_menu.addEventListener('keydown', handleKeyPress);
  valUpdateWrapper();
}

init();